import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=18ae967e&scoped=true"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"
import style1 from "./OrgChart.vue?vue&type=style&index=1&id=18ae967e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae967e",
  null
  
)

export default component.exports